import React from 'react';
import PropTypes from 'prop-types';
import AppProvider from '../AppProvider';
import styles from './App.scss';
import 'font-awesome/css/font-awesome.css';
import 'theme/fonts/adminFonts.scss';
import 'theme/icons/style.scss';
import '@storable/canaveral-components/styles.css';
import '@storable/canaveral-rte/styles.css';
import '../../theme/bootstrap-overrides.css';

/* eslint-disable global-require */
if (!Intl.PluralRules) {
  import('@formatjs/intl-pluralrules/polyfill');
  import('@formatjs/intl-pluralrules/dist/locale-data/en');
  import('@formatjs/intl-pluralrules/dist/locale-data/fr');
  import('@formatjs/intl-pluralrules/dist/locale-data/es');
}

if (!Intl.RelativeTimeFormat) {
  import('@formatjs/intl-relativetimeformat/polyfill');
  import('@formatjs/intl-relativetimeformat/dist/locale-data/en');
  import('@formatjs/intl-relativetimeformat/dist/locale-data/fr');
  import('@formatjs/intl-relativetimeformat/dist/locale-data/es');
}
/* eslint-enable global-require */

const propTypes = {
  children: PropTypes.object.isRequired,
};

const App = ({ children }) => (
  <AppProvider>
    <div className={styles.app}>
      {children}
    </div>
  </AppProvider>
);

App.propTypes = propTypes;

export default App;
